import Tasks from "../components/Task";

const Task = () => {
  return (
    <>
      <Tasks />
    </>
  );
};

export default Task;
